import React, { useEffect } from 'react';

/**
 * Wraps page content with:
 * 1. Page-enter animation
 * 2. Scroll-reveal IntersectionObserver
 */
export default function PageWrap({ children, testId }) {
  useEffect(() => {
    window.scrollTo(0, 0);

    const obs = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } }),
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.reveal, .reveal-l, .reveal-r').forEach(el => obs.observe(el));

    // count-up animation
    document.querySelectorAll('[data-count]').forEach(el => {
      const target = parseInt(el.dataset.count, 10);
      const dur = 1600;
      const start = performance.now();
      const step = (now) => {
        const p = Math.min((now - start) / dur, 1);
        el.textContent = Math.floor(p * target) + (el.dataset.suffix || '');
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });

    return () => obs.disconnect();
  }, []);

  return (
    <div className="page-enter" data-testid={testId}>
      {children}
    </div>
  );
}
